/**
 * schedule card having match number, teamA, teamB, time, Date
 * it has some predefined background
 * i need to put absolute positioning for contents to be placed inside the card
 * match number leftmost vertical text, teamA and teamB in the middle with vs in between, time and date right side
 */
import "./MatchScheduleCard.css";
export default function MatchScheduleCard({
  matchNumber,
  teamA,
  teamALogo,
  teamB,
  teamBLogo,
  time,
  date,
}) {
  return (
    <div className="match-schedule-card">
      <div className="match-number">{matchNumber}</div>
      <div className="teams">
        <div className="team">
          <img src={teamALogo} alt={teamA} className="team-logo" />
        </div>
        <div className="vs">vs</div>
        <div className="team">
          <img src={teamBLogo} alt={teamB} className="team-logo" />
        </div>
      </div>
      <div className="time-date">
        <div className="date">
          {date
            ? new Date(date).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                // year: "numeric",
              })
            : "TBD"}
        </div>
        <div className="time">
          {date
            ? new Date(date).toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : time && time !== "TBA"
            ? time
            : "TBA"}
        </div>
        
      </div>
    </div>
  );
}
